module.exports = "/assets/data/316ad4fbb382c1ed05ca5b57b179ddf5-SG6.data.json";